import React from 'react';



export const icons = {
  linkedin: (
    <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
    </svg>
  ),
  X: (
    <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  ),
  facebook: (
    <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
    </svg>
  ),
  instagram: (
    <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
    </svg>
  ),
  phone: (
    <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
    </svg>
  ),
  email: (
    <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
    </svg>
  ),
  hekaosLarge: (
    <svg className="w-10 h-10 sm:w-10 sm:h-10" viewBox="0 0 100 100" fill="none">
      <path d="M18 78 L50 18 L82 78" stroke="currentColor" strokeWidth="3" strokeLinejoin="round" strokeLinecap="round" fill="none" />
      <path d="M30 70 L50 32 L70 70" stroke="currentColor" strokeWidth="3" strokeLinejoin="round" strokeLinecap="round" fill="none" />
      <path d="M22 76 L32 78" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      <path d="M78 76 L66 78" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      <path d="M18 78 L34 78" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      <path d="M82 78 L66 78" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      <circle cx="50" cy="58" r="5" stroke="currentColor" strokeWidth="3" fill="none" />
      <path d="M42 68 L58 68 L50 82 Z" stroke="currentColor" strokeWidth="3" strokeLinejoin="round" fill="none" />
    </svg>
  ),
  location: (
    <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M12 2C8.134 2 5 5.134 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.866-3.134-7-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z" />
    </svg>
  ),
  github: (
    <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M12 .5C5.65.5.5 5.65.5 12c0 5.1 3.292 9.42 7.86 10.95.575.105.785-.25.785-.555 0-.273-.01-1-.015-1.965-3.197.695-3.873-1.542-3.873-1.542-.523-1.328-1.278-1.682-1.278-1.682-1.045-.715.08-.7.08-.7 1.155.082 1.763 1.186 1.763 1.186 1.027 1.76 2.695 1.252 3.35.957.104-.744.402-1.252.73-1.54-2.553-.29-5.236-1.276-5.236-5.68 0-1.255.448-2.28 1.184-3.083-.118-.29-.513-1.46.112-3.044 0 0 .966-.31 3.167 1.177.918-.255 1.902-.383 2.88-.388.978.005 1.963.133 2.882.388 2.198-1.487 3.162-1.177 3.162-1.177.627 1.584.232 2.754.114 3.044.738.803 1.182 1.828 1.182 3.083 0 4.415-2.688 5.387-5.25 5.67.413.355.78 1.057.78 2.13 0 1.538-.014 2.776-.014 3.154 0 .308.206.666.79.553C20.21 21.416 23.5 17.1 23.5 12c0-6.35-5.15-11.5-11.5-11.5z" />
    </svg>
  ),
  youtube: (
    <svg className="w-5 h-5 sm:w-6 sm:h-6" viewBox="0 0 24 24" fill="currentColor">
      <path d="M23.498 6.186a3.004 3.004 0 00-2.116-2.12C19.505 3.5 12 3.5 12 3.5s-7.505 0-9.382.566a3.004 3.004 0 00-2.116 2.12A31.247 31.247 0 000 12a31.247 31.247 0 00.502 5.814 3.004 3.004 0 002.116 2.12C4.495 20.5 12 20.5 12 20.5s7.505 0 9.382-.566a3.004 3.004 0 002.116-2.12A31.247 31.247 0 0024 12a31.247 31.247 0 00-.502-5.814zM9.75 15.568V8.432L15.818 12 9.75 15.568z" />
    </svg>
  ),
  hekaosOperator: (
    <svg
      className="w-9 h-9"
      viewBox="0 0 100 100"
      fill="none"
    >
      <defs>
        <radialGradient id="hekaGlow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="currentColor" stopOpacity="0.9" />
          <stop offset="100%" stopColor="currentColor" stopOpacity="0.15" />
        </radialGradient>
      </defs>
  
      {/* Outer Intelligence Ring */}
      <circle className="animate-pulse"
        cx="50"
        cy="50"
        r="48"
        stroke="currentColor"
        strokeWidth="3"
        opacity="0.6"
      />
  
      {/* Neural Nodes */}
      <circle cx="50" cy="20" r="5" fill="currentColor" />
      <circle cx="20" cy="70" r="5" fill="currentColor" />
      <circle cx="80" cy="70" r="5" fill="currentColor" />
  
      {/* Connections */}
      <line x1="50" y1="20" x2="20" y2="70" stroke="currentColor" strokeWidth="2" />
      <line x1="50" y1="20" x2="80" y2="70" stroke="currentColor" strokeWidth="2" />
      <line x1="20" y1="70" x2="80" y2="70" stroke="currentColor" strokeWidth="2" />
  
      {/* Core */}
      <circle className="animate-pulse" cx="50" cy="50" r="12" fill="url(#hekaGlow)" />
      <circle cx="50" cy="50" r="6" fill="currentColor" />
    </svg>
  )
};

